// extracted by mini-css-extract-plugin
export default {"wrapper":"page__wrapper___JAxAk","header":"page__header___oqgrE","body":"page__body___cT8FW","title":"page__title___IiTYO"};